<template>
  <ValidationObserver
    ref="formValidation"
    v-slot="{ invalid }"
    slim
  >
    <form
      role="form"
      name="annotateForm"
      class="form-horizontal p-t-10 p-b-10"
      novalidate
      @submit.prevent="annotateCallSubmit"
    >
      <div
        v-if="recentTags && recentTags.length > 0"
        class="form-group"
      >
        <label class="col-sm-2 col-md-3 control-label">{{ $t('PREVIOUS_LABEL') }}
          <a
            v-tooltip.right="$t('PREVIOUS_TT')"
          >
            &nbsp;&nbsp;<i class="fa fa-question-circle" />
          </a>
        </label>

        <div class="col-md-3">
          <SearchableDropdown
            v-model="dropdownTag"
            :config="recentTagsDropdownConfig"
          />
        </div>
      </div>

      <div
        class="form-group"
      >
        <label class="col-sm-2 col-md-3 control-label">{{ $t('TAG_NAME_LABEL') }}
          <a
            v-tooltip.right="$t('TAG_NAME_TT')"
          >
            &nbsp;&nbsp;<i class="fa fa-question-circle" />
          </a>
        </label>

        <div class="col-sm-3 col-md-2">
          <ValidationProvider
            v-slot="{ classes }"
            rules="required"
            slim
          >
            <input
              v-model="tag.name"
              v-focus
              class="form-control"
              :class="classes"
              :placeholder="$t('TAG_NAME_PLACEHOLDER')"
            >
          </ValidationProvider>
        </div>
      </div>

      <div
        class="form-group"
      >
        <label class="col-sm-2 col-md-3 control-label">{{ $t('TAG_VALUE_LABEL') }}
          <a
            v-tooltip.right="$t('TAG_VALUE_TT')"
          >
            &nbsp;&nbsp;<i class="fa fa-question-circle" />
          </a>
        </label>

        <div class="col-sm-3 col-md-2">
          <ValidationProvider
            v-slot="{ classes }"
            rules="required"
            slim
          >
            <input
              v-model="tag.value"
              class="form-control"
              :class="classes"
              :placeholder="$t('TAG_VALUE_PLACEHOLDER')"
            >
          </ValidationProvider>
        </div>
      </div>

      <div class="form-group">
        <div class="col-sm-offset-2 col-md-offset-3 col-md-7">
          <PrimaryButton
            size="sm"
            :disabled="invalid"
            :show-loader-on-form="showLoader"
            @click="annotateCallSubmit"
          >
            {{ $t('ADD_ANNOTATION_BTN') }}
          </PrimaryButton>

          <button
            v-t="'CANCEL'"
            type="button"
            class="btn btn-sm btn-danger m-l-15"
            @click="$emit('closeForm')"
          />
        </div>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import SearchableDropdown from '@/core/components/SearchableDropdown/SearchableDropdown';
import PrimaryButton from '@/core/components/PrimaryButton';
import sharedMessages from '@/core/locales';
import messages from './locales';

export default {
  name: 'TagAnnotateForm',

  components: {
    SearchableDropdown,
    PrimaryButton,
  },

  props: {
    existingSelectedTag: {
      type: Object,
      default() {
        return {};
      }
    },
    recentTags: {
      type: Array,
      default() {
        return [];
      }
    },
    showLoader: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      tag: {},
    };
  },

  computed: {
    dropdownTag: {
      get() {
        return this.tag;
      },
      set(value) {
        this.tag = value;
      }
    },

    recentTagsDropdownConfig() {
      let tagsSorted = [...this.recentTags]; 
      
      tagsSorted.sort(function sortCampaigns(tagA, tagB) {
        if (tagA < tagB) { 
          return -1; 
        }
          
        if(tagA > tagB) { 
          return 1; 
        }

        return 0;
      });

      return {
        options: tagsSorted,
        getOptionLabel(option) {
          return option?.key;
        },
        placeholder: this.$t('PREVIOUS_PLACEHOLDER')
      };
    }
  },

  mounted () {
    this.dropdownTag = this.existingSelectedTag;
  },

  beforeDestroy () {
    this.$emit('cacheFormData', this.tag);
  },

  methods: {
    annotateCallSubmit() {
      this.$emit('annotateCallSubmit', this.tag);
    },
  },
  i18n: {
    locale: 'en',
    messages,
    sharedMessages
  }
};
</script>

<style>

</style>